import { __rest } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { usePortal, useKeyboard, KeyCode } from '@websolutespa/bom-mixer-hooks';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

const Dialog = _a => {
  var {
      children,
      visible: customVisible
    } = _a,
    props = __rest(_a, ["children", "visible"]);
  const portal = usePortal('llm-dialog');
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (typeof customVisible === 'undefined') {
      return;
    }
    setVisible(customVisible);
  }, [customVisible]);
  const closeDrawer = () => {
    if (props.onClose) {
      props.onClose();
    }
    setVisible(false);
  };
  const {
    bindings
  } = useKeyboard(() => {
    closeDrawer();
  }, KeyCode.Escape, {
    disableGlobalEvent: true
  });
  const onBackdropClick = () => {
    closeDrawer();
  };
  if (!portal) {
    return null;
  }
  return /*#__PURE__*/createPortal(visible ? jsxs("div", Object.assign({
    className: "llm__dialog"
  }, bindings, {
    children: [jsx("div", {
      className: "llm__dialog__backdrop",
      onClick: onBackdropClick
    }), jsx("div", {
      className: "llm__dialog__wrapper",
      children: children
    })]
  })) : jsx(Fragment, {}), portal);
};

export { Dialog };
//# sourceMappingURL=dialog.js.map
